export default "/images/Privaposts-Media-icon.png?343c8a076973ff0c3bbac13b9237eb11";